import { Link } from 'react-router-dom';
import { getLatestComics } from '@/mocks/comics';

export default function LatestSection() {
  const latest = getLatestComics(8);
  const categoryNameMap: Record<string, string> = {
    romance: '恋爱',
    fantasy: '奇幻',
    action: '动作',
    thriller: '悬疑',
    comedy: '搞笑',
    drama: '剧情',
    horror: '恐怖',
    bl: 'BL/GL',
  };

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-12">
          <div>
            <span className="inline-block px-4 py-1 rounded-full bg-secondary-100 text-secondary-600 text-xs font-medium mb-4">
              每日更新
            </span>
            <h2
              className="text-2xl md:text-4xl font-bold text-foreground-950"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              最新更新
            </h2>
            <p className="mt-3 text-foreground-600 text-sm max-w-xl">
              每日更新最新章节，精彩内容不容错过
            </p>
          </div>
          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/romance"
              className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              查看全部 <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latest.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex gap-3 bg-background-100 rounded-lg p-3 hover:bg-background-200/70 transition-colors duration-300"
              data-product-shop
            >
              <div className="w-20 h-28 flex-shrink-0 overflow-hidden rounded-md">
                <img
                  src={comic.coverUrl}
                  alt={comic.title}
                  title={`${comic.title} - 免费韩国漫画在线阅读`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col justify-between min-w-0 flex-1">
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                    {comic.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                  <span className="inline-block mt-1.5 text-[10px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-600 whitespace-nowrap">
                    {categoryNameMap[comic.category] || comic.category}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {comic.views > 10000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}
                  </span>
                  <span>
                    共{comic.chapters}话
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}